import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import Reveal from './Reveal';
import { company } from '../data/site';

const CtaBand = ({
  title = 'Have a project in mind? Let\u2019s build it together.',
  text = 'Tell us what you need and get a free consultation and a fixed quote within one business day.'
}) => (
  <section className="section" style={{ paddingTop: 0 }}>
    <div className="container">
      <Reveal className="cta-band">
        <h2>{title}</h2>
        <p>{text}</p>
        <div className="btn-row">
          <Link to="/contact" className="btn btn-lg">
            Book a free consultation <FiArrowRight />
          </Link>
          <a href={company.whatsapp} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-lg">
            <FaWhatsapp /> Chat on WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaBand;
